import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  DialogContentText,
} from '@mui/material';
import { useState } from 'react';
import { blue } from '@mui/material/colors';

const useConfirmDialog = () => {
  const [params, setParams] = useState({
    open: false,
    name: '',
    onConfirm: () => new Promise(() => {}),
  });
  const [submiting, setSubmiting] = useState(false);

  const closeDialog = () => {
    setParams({ ...params, open: false });
  };

  const ConfirmDialog = (props: any) => {
    const { actionName, dialogTitle } = props;
    return (
      <Dialog open={params.open} onClose={closeDialog} maxWidth="sm" fullWidth>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <DialogTitle
            sx={{
              backgroundColor: blue[500],
              color: 'white',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {actionName}
          </DialogTitle>

          <DialogContent>
            <DialogContentText>
              <Box sx={{
                pt: 5
              }}>{dialogTitle}</Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setSubmiting(true);
                params
                  .onConfirm()
                  .then(() => {
                    closeDialog();
                  })
                  .finally(() => {
                    setSubmiting(false);
                  });
              }}
              variant="contained"
              disabled={submiting}
              sx={{ backgroundColor: blue[500], color: 'white' }}
            >
              Igen
            </Button>
            <Button onClick={closeDialog} color="primary" variant="outlined">
              Nem
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    );
  };
  return {
    ConfirmDialog,
    setParams: setParams,
    params,
  };
};
export default useConfirmDialog;
